
<template>
  <div class="auth-container min-h-screen flex items-center justify-center">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 z-20 relative">
          <div class="max-w-6xl mx-auto">
        <div class="rounded-2xl p-8 md:p-10 ">
          <h1 class="text-3xl font-bold text-white text-center mb-8">
            <slot name="title">Acceso</slot>
          </h1>
          
          <!-- Contenido principal (formulario) -->
          <slot></slot>
          <!-- Autenticación social -->
          <slot name="social-auth"></slot>
          <!-- Enlaces de pie de página -->
          <slot name="footer-links"></slot>
        </div>
      </div>
      

    </div>
  </div>
</template>

<style scoped>
.auth-container {
  background-image: url('@/assets/img/bg-main.png');
}
@media (max-width: 768px) {
  .auth-container::before {
    background-size: 300px;
  }
}

/* Efecto de animación sutil para los elementos */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.backdrop-blur-md {
  animation: fadeIn 0.6s ease-out forwards;
}
</style>